export const getLocationSearch = () => globalThis?.window?.location.search ?? '';

export const getQueryParams = (search: string) => {
	const searchParams = new URLSearchParams(search);
	return Object.fromEntries(searchParams.entries());
};
